import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scMathRound',
})
export class MathRoundPipe implements PipeTransform {
  transform(num: number): number {
    return num ? Math.round(num) : 0;
  }
}
